import { cu1, cu2, cu3, whyus1, whyus2, whyus3 } from "../assets/imagesPath";

export const chooseusData = [
    {
      imageSrc: cu1,
      title: 'Expertise You Can Trust',
      description:
        'Decades of financial and business experience, including leadership roles and recognition in Marquis Who’s Who in America.',
    },
    {
      imageSrc: cu2,
      title: 'Tailored for Small Businesses',
      description:
        'Our solutions are built with the unique needs of tradespeople and small business owners in mind.',
    },
    {
      imageSrc: cu3,
      title: 'High-Value Results',
      description:
        'We focus on delivering measurable results that improve your bottom line.',
    },
  ];

  export const aboutusData = [
    {
      imageSrc: whyus1,
      title: 'Struggling with Finances?',
      description:
        'Our bookkeeping and financial planning services give you clarity and control.',
    },
    {
      imageSrc: whyus2,
      title: 'Feeling Isolated?',
      description:
        'Our networking opportunities connect you with a community of like-minded entrepreneurs.',
    },
    {
      imageSrc: whyus3,
      title: 'Too Many Moving Parts?',
      description:
        'Our partnerships simplify complex tasks like payroll, taxes, and legal compliance.',
    },
  ];

  export const servicesData = [
    {
      imageSrc: whyus1,
      title: 'Expert Guidance',
      description:
        'Get personalized advice from industry professionals who understand your challenges.',
      linkHref: '#',
    },
    {
      imageSrc: whyus2,
      title: 'Comprehensive Support',
      description:
        'From financial planning to marketing, we offer services that grow with your business.',
      linkHref: '#',
    },
    {
      imageSrc: whyus3,
      title: 'Tailored Solutions',
      description:
        'Our services are customized to fit the unique needs of your business.',
      linkHref: '#',
    },
  ];